var map = {
	"./symbol_0.png": 47478,
	"./symbol_1.png": 43807,
	"./symbol_10.png": 67471,
	"./symbol_11.png": 28454,
	"./symbol_12.png": 69693,
	"./symbol_13.png": 32212,
	"./symbol_14.png": 94475,
	"./symbol_15.png": 73346,
	"./symbol_16.png": 21529,
	"./symbol_17.png": 24624,
	"./symbol_18.png": 75159,
	"./symbol_19.png": 32142,
	"./symbol_2.png": 89156,
	"./symbol_3.png": 29101,
	"./symbol_4.png": 56594,
	"./symbol_5.png": 70811,
	"./symbol_6.png": 92480,
	"./symbol_7.png": 47305,
	"./symbol_8.png": 18398,
	"./symbol_9.png": 36711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57729;